// src/components/Blog.js
import React from 'react';
import { Helmet } from 'react-helmet';
import '../styles/App.css'; // Import the consolidated App.css

function Blog() {
  // Example blog data (no images)
  const blogPosts = [
    {
      id: 1,
      title: 'AI-Driven Sports Training',
      description:
        'Discover how artificial intelligence is revolutionizing athletic performance. From personalized workouts to predictive injury analytics—learn the latest trends driving modern sports.',
      link: '/blog/ai-driven-sports-training',
      date: '2024-12-01',
      author: 'Jane Doe',
      tags: ['AI', 'Sports', 'Training'],
    },
    {
      id: 2,
      title: '5 Tips for Injury Prevention',
      description:
        'Learn practical methods to reduce injury risk and speed up your recovery. Perfect for athletes looking to stay ahead of potential setbacks.',
      link: '/blog/injury-prevention-tips',
      date: '2024-11-15',
      author: 'John Smith',
      tags: ['Health', 'Injury Prevention', 'Fitness'],
    },
    // Add more posts as needed
  ];

  return (
    <div className="blog-page">
      {/* Helmet for Meta Tags */}
      <Helmet>
        <title>WizeAssist Blog | AI in Sports, Training Tips, and Injury Prevention</title>
        <meta
          name="description"
          content="Explore WizeAssist's blog for the latest articles on AI in sports, training tips, and injury prevention strategies."
        />
        {/* Additional OG/Twitter meta tags can be added here */}
      </Helmet>

      <h1 className="blog-page-title">WizeAssist Blog & Resources</h1>
      <p className="blog-intro">
        Welcome to our knowledge hub where we share insights on AI-driven sports training,
        fitness strategies, and cutting-edge research to keep you at the top of your game.
      </p>

      <div className="blog-posts-grid">
        {blogPosts.map((post) => (
          <div key={post.id} className="blog-post-card">
            {/* Optional: Add an image if available */}
            {/* <img src={post.image} alt={post.title} className="blog-post-image" /> */}
            <div className="blog-post-content">
              <h3 className="blog-post-title">
                <a href={post.link}>{post.title}</a>
              </h3>
              <p className="blog-post-description">
                {post.description}
              </p>
              <div className="blog-post-meta">
                <span>{new Date(post.date).toLocaleDateString()}</span>
                <span>By {post.author}</span>
              </div>
              <div className="blog-post-tags">
                {post.tags.map((tag, index) => (
                  <a
                    key={index}
                    href={`/tags/${tag.toLowerCase().replace(' ', '-')}`}
                    className="blog-post-tag"
                  >
                    #{tag}
                  </a>
                ))}
              </div>
              <a href={post.link} className="read-more-btn">
                Read More »
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Blog;
